export default {
    props: {
        additionColumns: String,
        customColumns: String
    },
    data() {
        return {
            additionColumnSet: null,
            customColumnSet: null,
            additionFrontSet: new Set(),
        }
    },
    created() {
        this.additionColumnSet = this.splitStrToSet(this.additionColumns);
        this.customColumnSet = this.splitStrToSet(this.customColumns);
    },
    methods: {
        splitStrToSet(str) {
            if (str) {
                let temp = new Set();
                let split = str.split(",");
                for (let item of split) {
                    if (item.startsWith('#')) {
                        item = item.substring(1);
                        this.additionFrontSet.add(item);
                    }
                    temp.add(item);
                }
                return temp;
            } else {
                return null;
            }
        },
        isAdditionColumn(data) {
            return this.additionColumnSet && this.additionColumnSet.has(data.field.key);
        },
        isAdditionFront(data) {
            return this.additionFrontSet.has(data.field.key);
        },
        isCustomColumn(data) {
            return this.customColumnSet && this.customColumnSet.has(data.field.key);
        },

        additionSlotName(data) {
            return 'addition(' + data.field.key + ')';
        },
        customSlotName(data) {
            return 'custom(' + data.field.key + ')';
        },

        slotNames() {
            let tempList = [];
            if (this.additionColumnSet) {
                Array.from(this.additionColumnSet).forEach(o => tempList.push('addition(' + o + ')'));
            }
            if (this.customColumnSet) {
                Array.from(this.customColumnSet).forEach(o => tempList.push('custom(' + o + ')'));
            }
            return tempList;
        },
    },
}
